import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {RouterModule} from "@angular/router";
import {FilePreviewComponent} from "./file-preview.component";
import {FilesService} from "../../models/files/files.service";
import {PipesModule} from "../../pipes/pipes.module";
import {UrlHelperService} from "../../services/url-helper.service";
import { PdfViewerComponent } from 'ng2-pdf-viewer';

@NgModule({
    declarations: [
        FilePreviewComponent,
        PdfViewerComponent
    ],
    imports     : [BrowserModule, RouterModule, PipesModule],
    providers: [
        UrlHelperService,
        FilesService,
    ]
})

export class FilePreviewModule {}


// WEBPACK FOOTER //
// ./src/app/views/file-preview/file-preview.module.ts